import { render, staticRenderFns } from "./hand.vue?vue&type=template&id=fe663700&scoped=true&"
import script from "./hand.vue?vue&type=script&lang=ts&"
export * from "./hand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe663700",
  null
  
)

export default component.exports